import { useFeatureUpgradeDetailsModal } from '@frontend/self-upgrade';

export const actionsNotPartOfFreemium = [
  'sync',
  'customize_kiosk_forms',
  'create_new_form_from_modal',
  'edit_form',
  'use_this_template',
  'packet_listing',
  'packet_creation',
  'builder_view',
  'request_digitization_view',
  'form_listing_view',
  'clone_form',
  'packet_view',
  'review_required',
  'writeback_sources',
  'writeback_settings',
  'provider_mapping',
  'customize_kiosk',
  'medical_condition_settings',
] as const;

export type ActionNotPartOfFreemium = (typeof actionsNotPartOfFreemium)[number];

export type UseFreemiumResults = {
  isFreemium: boolean;
  freemiumLocationIds: string[];
  isActionBlocked: (action: ActionNotPartOfFreemium, locationId?: string) => boolean;
  featureUpgradeDetailsModalControls: ReturnType<
    typeof useFeatureUpgradeDetailsModal
  >['featureUpgradeDetailsModalControls'];
};
